import { Stack, Typography } from '@mui/material';

type Props = { title: string; message?: string };

export const StackedSnackbar = ({ title, message }: Props) => {
  return (
    <Stack spacing={0.5}>
      <Typography fontWeight={600}>{title}</Typography>
      {message && <Typography variant="body2">{message}</Typography>}
    </Stack>
  );
};
